import { render, staticRenderFns } from "./ProfileInteractions.vue?vue&type=template&id=00c99428"
import script from "./ProfileInteractions.vue?vue&type=script&lang=js"
export * from "./ProfileInteractions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports